import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import LoginScreen from "../LoginScreen";
import HeaderNavigation from "../../components/HeaderNavigation/HeaderNavigation";
import * as authSelectors from "../../store/auth/reducer";
import * as authActions from "../../store/auth/actions";

//Test loading modules, this would be moved to when use signs in
import * as moduleActions from "../../store/ServiceModules/actions";
import * as moduleSelectors from "../../store/ServiceModules/reducer";
import * as settingActions from "../../store/ConciergeSetting/actions";
import * as settingSelector from "../../store/ConciergeSetting/reducer";
class AuthArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modules: [],
      settings: []
    };
    this.props.dispatch(settingActions.getGlobalSetting());
    this.props.dispatch(moduleActions.loadModules());

  }
  componentDidMount() {
    this.props.dispatch(authActions.login());
    this.props.dispatch(authActions.fetchConciergeDetails());
  }

  handlelogout() {
    this.props.dispatch(authActions.logout());
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (
      this.props.modules !== nextProps.modules &&
      !_.isUndefined(nextProps.modules)
    ) {
      if (nextProps.modules && nextProps.modules.length > 0)
        this.setState({
          modules: nextProps.modules
        });
    }
    if (
      this.props.setting !== nextProps.setting &&
      !_.isUndefined(nextProps.setting)
    ) {
      if (nextProps.setting && nextProps.setting.length > 0)
        this.setState({
          settings: nextProps.setting
        });
    }
  }

  render() {
    const { modules, setting } = this.props;
    const mainBackground = setting && setting.mainBackgroundImage;
    const body_style = {
      backgroundImage: "url('" + mainBackground + "')",
      "backgroundRepeatY": "no-repeat",
      "backgroundSize": "cover"
    }


    if (this.props.isLoggedIn && modules !== null)
      return (
        <div>
          <HeaderNavigation
            isLoggedIn={this.props.isLoggedIn}
            modules={modules}
            setting={setting}

          />
          <div className="main-wrp root" style={body_style}>
            <main className="content">{this.props.children}</main>
          </div>
        </div>
      );
    else return <LoginScreen />;
  }
}

AuthArea.propTypes = {
  children: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    isLoggedIn: authSelectors.getIsLoggedIn(state),
    modules: moduleSelectors.loadModules(state),
    setting: settingSelector.loadGlobalSetting(state)
  };
}

export default connect(mapStateToProps)(AuthArea);



// WEBPACK FOOTER //
// ./src/containers/concierge/AuthArea.js